import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './de';
import en from './en';

export const LANGUAGES = ['de', 'en'] as const;
export type Language = (typeof LANGUAGES)[number];

const STORAGE_KEY = 'ewigbyte.lang';

function detectInitialLanguage(): Language {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'de' || stored === 'en') return stored;
  } catch {
    // localStorage unavailable (e.g. SSR/tests) — fall through.
  }
  // Default language is German per UX mandate.
  return 'de';
}

export function initI18n() {
  if (!i18n.isInitialized) {
    void i18n.use(initReactI18next).init({
      resources: {
        de: { translation: de },
        en: { translation: en },
      },
      lng: detectInitialLanguage(),
      fallbackLng: 'de',
      interpolation: { escapeValue: false },
      returnNull: false,
    });
  }
  return i18n;
}

export function setLanguage(lang: Language) {
  void i18n.changeLanguage(lang);
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    // ignore persistence failures
  }
  if (typeof document !== 'undefined') document.documentElement.lang = lang;
}

export default i18n;
